/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsLogosTicker = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsLogosTicker = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);

    this.loadImages();
  },
  loadImages: function () {
    let icons = this.element.querySelectorAll(".lazyload");
    icons.forEach((image)=>{
      lazySizes.loader.unveil(image);
    });
  },
  unload: function($section) {
  }
}

/******/ })()
;